import {
  useWSSnackbar,
  WSForm,
  WSInputTextarea,
  WSModal
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { useMutationUpdateWorkLog } from "../../../../query/workLog/mutations/useMutationUpdateWorkLog";

type FormData = {
  notes: string;
};

type Props = {
  workLogId: string;
  currentNotes?: string;
  onClose: (success: boolean) => void;
};

export const ModalEditWorkLogNotes: React.FC<Props> = ({
  workLogId,
  currentNotes,
  onClose
}) => {
  const { openSnackbar } = useWSSnackbar();
  const [updateWorkLog, updateWorkLogMeta] = useMutationUpdateWorkLog();

  return (
    <WSForm<FormData>
      defaultValues={{ notes: currentNotes || "" }}
      validationSchema={Yup.object().shape({
        notes: Yup.string().max(2000, "Notes must be 2000 characters or less")
      })}
      onSubmit={async formData => {
        await updateWorkLog(
          { workLogId, request: { notes: formData.notes } },
          {
            onSuccess: () => {
              openSnackbar({
                icon: { name: "check" },
                message: "Notes updated"
              });
              onClose(true);
            },
            onError: () => {
              openSnackbar({
                message: "Failed to update notes",
                type: "error"
              });
            }
          }
        );
      }}
    >
      <WSModal
        title="Notes"
        size="S"
        onClose={() => onClose(false)}
        actions={{
          alignment: "fill",
          buttons: [
            {
              kind: "Tertiary",
              label: "Cancel",
              type: "button",
              onClick: () => onClose(false)
            },
            {
              kind: "Primary",
              label: "Save",
              loading: updateWorkLogMeta.isLoading,
              type: "submit"
            }
          ]
        }}
      >
        <WSForm.Field
          name="notes"
          label="Notes"
          component={WSInputTextarea}
          componentProps={{
            placeholder: "Add notes for this work log...",
            maxLength: 2000
          }}
        />

        <WSErrorMessage
          mt="M"
          contextKey="Other"
          error={updateWorkLogMeta.error}
        />
      </WSModal>
    </WSForm>
  );
};
